/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
      suggestionStyle2MainContainerSelector:".c-header__search-bar",
      suggestionMobileStyle:'style2',
      suggestionBlocks: [
        {type: 'suggestions', label: 'Suggestions', status: 'active', number: 3},
        {type: 'collections', label: 'Collections', status: 'active', number: 3},
        {type: 'pages', label: 'Pages', status: 'active', number: 3},
        {type: 'products', label: 'Products', status: 'active', number: window.innerWidth < 767 ? 4 : 5}
      ]
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  /* Fix input doesn't focus in Brooklyn theme */
  InstantSearchStyle3.prototype.afterCloseInstantSearchStyle3 = function(isClose) {
    jQ('.mfp-close').trigger('click');
  }
  
  InstantSearchResultBlockDym.prototype.setData = function(data) {
		this.data = data;
		this.isShow = false;
		if (data) {
			var isLocalCache = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.LOCAL_CACHE, this.data);
			if (isLocalCache) {
				this.totalProduct = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.TOTAL_PRODUCT, this.data);
				this.totalProductFromSuggestedQuery = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.SUGGEST_TOTAL_PRODUCT, this.data);
				this.dymList = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.DID_YOU_MEAN, this.data);
				this.suggestQuery = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.SUGGEST_QUERY, this.data);
				this.isShow = true;

			} else {
				var isSuggestedCall = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.PREV_QUERY, this.data);
				// 1st call, have dym
				if (!isSuggestedCall) {
					this.totalProduct = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.TOTAL_PRODUCT, this.data);
					this.totalProductFromSuggestedQuery = 0;
					this.dymList = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.DID_YOU_MEAN, this.data);
					this.suggestQuery = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.SUGGEST_QUERY, this.data);
					this.isShow = true;

				// 2nd call, dym returns products
				} else {
					this.totalProduct = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.PREV_TOTAL_PRODUCT, this.data);
					this.totalProductFromSuggestedQuery = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.TOTAL_PRODUCT, this.data);
					this.isShow = true;
				}
			}
		}
	}
  
  InstantSearchResultBlockEmpty.prototype.compileTemplate = function() {
		return '';
	}

    /* BOOST-FIX: PFSN-32680 */
    SearchAutoComplete.prototype._response = function(data) {
        if (this._isXSSSearchTerm()) return;

        // Double check for current query before render, in case user type too fast
        var currentTerm = Utils.stripHtml(this.$inputElement.val());
        var eventType = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.EVENT_TYPE, data);
        var apiTerm = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.QUERY, data);
        // suggest_dym event always have different search term than the one in search box
        if (eventType == 'suggest_dym' || (currentTerm != '' && apiTerm != '')) {
            this.$element.html('');
            this.keyboardNavIndex = -1;
            this.$keyboardSelectedItem = null;

            var currentData = data;
            if (Globals.suggestionCache.hasOwnProperty(Globals.currentTerm)) {
                var currentData = Globals.suggestionCache[Globals.currentTerm];
            }
            this.searchInput._bindAutoCompleteRenderMenu(this.$element[0], currentData);
            var autocompleteUi = {content: data};
            this.searchInput._bindAutoCompleteResponse(this.currentEvent, autocompleteUi);

            var isEmpty = this.searchResult.$wrapper.find('[data-group]:not([data-group="view-all"]').length == 0;
            if (!isEmpty) {
                this.searchResult.$wrapper.show();
                this.searchResult.$wrapper.addClass(Class.searchSuggestionOpen);
                this.searchInput.$element.attr('aria-expanded', true);
            } else {
                this.searchResult.$wrapper.hide();
                this.searchResult.$wrapper.removeClass(Class.searchSuggestionOpen);
                this.searchInput.$element.attr('aria-expanded', false);
            }
        }
    }
    /* BOOST-END: PFSN-32680 */

    InstantSearchResultItemProduct.prototype.compileTemplate = function() {
        if (this.isShow) {
            var searchTerm = Utils.stripHtml(Globals.currentTerm);
            // Product image
            var imageHTML = '';
            if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
                imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
                const newImageUrl = this.imageUrl.replace('200x','350x')
                imageHTML = imageHTML.replace(/{{imageUrl}}/g, newImageUrl);
            }
            // Product title
            var productTitle = this.customizeProductTitle();
            productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
            // SKU
            var skuHTML = '';
            if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
                skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
                skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
            }
            // Vendor
            var vendorHTML = '';
            if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
                vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
                vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
            }
            // Price
            var priceHTML = this.compileSuggestionProductPrice();
            // Open the result item in new tab when selected
            var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

            return this.getTemplate()
                .replace(/{{id}}/g, this.id)
                .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
                .replace(/{{url}}/g, this.url)
                .replace(/{{newTabAttribute}}/g, newTabAttr)
                .replace(/{{itemProductImage}}/g, imageHTML)
                .replace(/{{title}}/g, productTitle)
                .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
                .replace(/{{itemProductSku}}/g, skuHTML)
                .replace(/{{itemProductVendor}}/g, vendorHTML)
                .replace(/{{itemProductPrice}}/, priceHTML)
                .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
                .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
                .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
        } else {
            return '';
        }
    }

})();
